<h5 class="h5 mt-0">{{ 'forgottenPassword.jaga-minimumRequirements' | cxTranslate }}</h5>
<ul class="requirements">
  <li class="requirement" [ngClass]="getValidationClass(requirement)" *ngFor="let requirement of requirements">
    {{ 'forgottenPassword.jaga-requirements.' + requirement | cxTranslate }}
  </li>
</ul>
